import React from "react";

const RadioButton = ({ name, value, checked, onChange, label, className }) => (
  <label className={className}>
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={() => onChange(value)}
    />
    {label}
  </label>
);

export default RadioButton;
